// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "treatment_plan".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "treatment_plan" table (1:1 with a DB row, on the wire). */
export const treatmentPlanAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    submissionId: z.string(),
    leadId: z.string(),
    title: z.string(),
    body: z.string(),
    status: z.enum(['draft', 'published']),
    publishedAt: z.string().datetime().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=treatmentPlan.js.map